import React, { useRef } from "react";
import { openConfirmAlert } from "@ctsu/react-ctsu-ui";

import { putWithAuth } from "protocol-setup/redux/makeFetch";
import { FasTimesCircle } from "assets/icons";
import { defaultErrorMessage } from "protocol-setup/redux/constants";
import { useHistory } from "react-router-dom";
import {
  OpenErrorNotification
} from "../notification";
import { statusUpdateUrl } from "../../redux/constants";

const CancelRequest = ({ requestId, item, index, getIcon, disabled }) => {
  const history = useRef(useHistory());
  const buttonRef = useRef(null);

  const handleClick = () => {
    openConfirmAlert({
      title: (
        <div className="d-flex align-items-center">
          <FasTimesCircle className="mr-1 color-grey-disabled" />
          <span>Canceled-status Request</span>
        </div>
      ),
      message: (
        <div>
          <p>
            Please confirm you would like to change this Protocol Setup Request{" "}
            <span>{requestId}</span> to Canceled-status.
          </p>
          <p>
            If you did not mean to change the status of this request, please
            Cancel.
          </p>
        </div>
      ),
      buttons: [
        {
          label: "Confirm",
          onClick: async () => {
            try {
              // Update request status to CANCELED via API
              await putWithAuth(statusUpdateUrl, {
                requestNumber: requestId,
                requestStatus: "CANCELED"
              });

              history.current.push("/protocol-setup/browser", {
                showSuccessMessage: true,
                message: "Record successfully updated."
              });
            } catch (error) {
              OpenErrorNotification({
                message: error?.message || defaultErrorMessage
              });
            }
          },
          className: ""
        },
        {
          label: "Cancel",
          onClick: () => { 
            if (buttonRef.current) {
              setTimeout(() => {
                buttonRef.current.focus();
              }, 0);
            }
          },
          className: "close"
        }
      ]
    });
  };
  if (item?.disabled) {
    return null;
  }
  return (
    <button
      ref={buttonRef}
      key={`${item.requestNumber}_${index}`}
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className={`btn mx-1 summary-bar-item ${item.disabled ? "disabled" : ""}`}
    >
      {item.displayBefore && (
        <span
          data-requestnumber={`${item.requestNumber}-summary-${item.key}`}
          className="summary-bar-key"
        >
          {getIcon(item.icon)}
        </span>
      )}
      <span
        data-requestnumber={`${item.requestNumber}-summary-${item.value.split(" ")[0]
          }`}
        className="summary-bar-value"
      >
        {item.value}
      </span>
      {!item.displayBefore && (
        <span
          data-requestnumber={`${item.requestNumber}-summary-${item.key}`}
          className="summary-bar-key"
        >
          {getIcon(item.icon)}
        </span>
      )}
    </button>
  );
};

export default CancelRequest;
